export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_responsibility_page-584f07a5359217d941fc785f538882bd.jpg";